/**
 * Created by hp on 2017/8/21.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Page, WKError} from '../components';
import {WKPreload} from '../components/wk';
import '../css/page/RelaySettingSharePage.css';
import card from '../images/relay-share-card.png';
import errorImg from '../images/no-source.png'


class RelaySettingSharePage extends Component {
    constructor() {
        super();
        this.state = {
            initialized: false,
        };
    }

    componentDidMount() {
        const {id} = this.props.params;
        axios.get(`/api/relay/lecture/${id}/invite_info`).then(res => {
            if (res.data.code === 0) {
                this.setState({initialized: true});
                let shareInfo = res.data.data.share_info;
                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: shareInfo.share_title,
                        desc: shareInfo.share_description,
                        imgUrl: shareInfo.share_icon,
                        link: shareInfo.share_url,
                    }
                });
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.data.msg,
                        img: errorImg,
                        href: '/',
                        btn: '回到首页'
                    }
                })
            }
        }).catch(error => {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '糟糕！访问的页面被外星人挟持啦～',
                    img: errorImg,
                    href: '/',
                    btn: '回到首页'
                }
            })
        });
    }

    render() {
        const {initialized} = this.state;
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="relay-setting-share-page wk-inner-page">
                    <WKError />
                </div>
            )
        }

        if (!initialized) {
            return <WKPreload />
        }

        return(
            <Page>
                <div className="relay-setting-share-page wk-inner-page">
                    <div className="inner">
                        <div className="share-card-content">
                            <div className="share-card">
                                <img src={card}/>
                            </div>

                            <div className="share-text">
                                <p>1.点击右上角，分享给群主</p>
                                <p>2.群主点击链接，即可创建转载间</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        )
    }
}

export default  connect((state) => ({
    error: state.error,
}))(RelaySettingSharePage)



// WEBPACK FOOTER //
// ./src/pages/RelaySettingSharePage.js